"use client";

import React, { createContext, useContext, useState } from "react";
import {
  AuthorizedProgressContextState,
  useServiceProgressContext,
} from "@/hooks/progress-context/use-service-progress-provider";
import { forceCancelTtm, getActiveTtmById } from "@/actions/db/text-to-musics";

interface TextToMusicProgressContextState
  extends AuthorizedProgressContextState {
  result: string;
}

const TextToMusicProgressContext = createContext<
  TextToMusicProgressContextState | undefined
>(undefined);

export const useTextToMusicProgressContext =
  (): TextToMusicProgressContextState => {
    const context = useContext(TextToMusicProgressContext);
    if (!context) {
      throw new Error(
        "useTextToMusicProgressContext must be used within an TextToMusicProgressContext",
      );
    }
    return context;
  };

export const TextToMusicProgressProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [result, setResult] = useState<string>("");

  const handleCompleteMessage = async (message: any) => {
    const savedSong = message.songs;
    setResult(savedSong);
  };

  const baseContext = useServiceProgressContext({
    forceCancelProcess: forceCancelTtm,
    getActiveItemByUserId: getActiveTtmById,
    handleCompleteMessage,
    taskType: "textToMusic",
  });

  return (
    <TextToMusicProgressContext.Provider value={{ ...baseContext, result }}>
      {children}
    </TextToMusicProgressContext.Provider>
  );
};
